import appEnv from 'bundles/enterprise-org-home/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
